<span *ngIf="filter">
	<strong>{{ filter.propertyName }}</strong>
	<span *ngIf="filter.operator">
		{{ getOperatorSymbol(filter.operator) }}
	</span>
	<ng-container *ngTemplateOutlet="filterTemplate; context: { $implicit: filter }"></ng-container>
</span>
<span *ngIf="!filter && filterList && displayType === 'table'">
	<ng-container *ngTemplateOutlet="filterTable"></ng-container>
</span>
<span *ngIf="!filter && filterList && displayType === 'card'" class="display-card">
	<nz-card nzTitle="Filter(s)" style="width: 100%">
		<ng-container *ngTemplateOutlet="filterTable"></ng-container>
	</nz-card>
</span>

<ng-template #filterTable>
	<nz-table nzSize="small" [nzData]="filterList" [nzFrontPagination]="false">
		<thead>
			<tr>
				<th>Name</th>
				<th>Value</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let filter of filterList">
				<td>{{filter.propertyName}}</td>
				<td>
					{{filter.operator ? getOperatorSymbol(filter.operator) + ' ' : ''}}
					<ng-container *ngTemplateOutlet="filterTemplate; context: { $implicit: filter }"></ng-container>
				</td>
			</tr>
		</tbody>
	</nz-table>
</ng-template>


<ng-template #filterTemplate let-filter>
	<span [ngSwitch]="getValueType(filter)">
		<span *ngSwitchCase="'Date'">
		{{ filter.value | date:'yyyy-MM-dd' }}
		</span>
		<span *ngSwitchCase="'SelectFromRecords'">
		{{ filter.value?.label || filter.value }}
		</span>
		<span *ngSwitchCase="'DropDownSingle'">
		{{ filter.value?.label || filter.value }}
		</span>
		<span *ngSwitchDefault>
		{{ filter.value }}
		</span>
	</span>
</ng-template>